<div class="container coursesList fadeIn mb-5 mt-md-5">
  <header class="sgrid-head mb-4">
    <ng-container *ngIf="loading; else headContent">
      <div class="skeleton skeleton--title"></div>
      <div class="skeleton skeleton--text skeleton--line-40"></div>
    </ng-container>
    <ng-template #headContent>
      <h2 class="sgrid-head__title">{{ title }}</h2>
      <p class="sgrid-head__subtitle">{{ subtitle }}</p>
    </ng-template>
  </header>

  <!-- Skeleton cards -->
  <div class="row block-sliders-grid2" *ngIf="loading">
    <div [class]="gridColClass + ' mb-4'" *ngFor="let s of skeletonCards">
      <div class="grid2-card grid2-card--skeleton">
        <div class="skeleton skeleton--image" style="height: 180px"></div>
        <div class="grid2-card__body">
          <div class="skeleton skeleton--text skeleton--line-60"></div>
          <div class="skeleton skeleton--text"></div>
          <div class="skeleton skeleton--text skeleton--line-80"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="row block-sliders-grid2" *ngIf="!loading">
    <div
      [class]="gridColClass + ' animate__animated animate__fadeIn mb-4'"
      *ngFor="let slide of slides"
    >
      <a
        class="grid2-card"
        [class.grid2-card--none]="slide.bgType === 'none'"
        [class.grid2-card--color]="slide.bgType === 'color'"
        [class.grid2-card--image]="slide.bgType === 'image'"
        [class.grid2-card--has-image]="slide.hasImage"
        [style.background-color]="slide.bgType === 'color' ? (slide.backgroundColor || null) : null"
        [style.background-image]="slide.bgType === 'image' && slide.image ? 'url(' + slide.image + ')' : null"
        [style.--grid2-bg]="slide.bgType === 'color' ? (slide.backgroundColor || null) : null"
        [style.--grid2-hover]="slide.bgType === 'color' ? (slide.backgroundColorHover || slide.backgroundColor || null) : null"
        [style.--grid2-accent]="secondaryColor"
        [attr.href]="slide.url || null"
        rel="noopener"
        (click)="onCardClick(slide, $event)"
      >
        <div class="grid2-card__media" *ngIf="slide.hasImage">
          <img
            [src]="slide.image"
            [alt]="slide.title || ''"
            onError="this.src='assets/images/placeholder.svg'"
            loading="lazy"
            decoding="async"
          />
        </div>

        <div class="grid2-card__body">
          <h3 class="grid2-card__title" *ngIf="slide.title">{{ slide.title }}</h3>
          <div class="grid2-card__desc" *ngIf="slide.description">{{ slide.description }}</div>

          <span
            class="grid2-card__cta"
            [class.grid2-card__cta--plain]="!slide.hasImage"
            *ngIf="slide.url"
            aria-hidden="true"
          >
            <i class="fas fa-arrow-up grid2-card__cta-arrow"></i>
          </span>
        </div>
      </a>
    </div>
  </div>
</div>
